import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkles, Database, Plug, Bot, ChevronRight, GitFork, Boxes } from "lucide-react";

const CONCEPTS = [
  {
    to: "/concepts/llm-introduction",
    icon: Sparkles,
    title: "How LLMs Work",
    desc: "Tokenization, embeddings, self-attention, and autoregressive decoding.",
  },
  {
    to: "/concepts/rag-explained",
    icon: Database,
    title: "How RAG Works",
    desc: "Retrieval-augmented generation: vector search, grounded answers, citations.",
  },
  {
    to: "/concepts/mcp-explained",
    icon: Plug,
    title: "How MCP Works",
    desc: "Model Context Protocol: JSON-RPC, tool discovery, capability negotiation.",
  },
  {
    to: "/concepts/agents-explained",
    icon: Bot,
    title: "How AI Agents Work",
    desc: "ReAct loops, tool use, memory systems, planning, and multi-agent architectures.",
  },
  {
    to: "/concepts/knowledge-graphs",
    icon: GitFork,
    title: "How Knowledge Graphs Work",
    desc: "Nodes, edges, triples, graph traversal, and reasoning over relationships.",
  },
  {
    to: "/concepts/vector-databases",
    icon: Boxes,
    title: "How Vector Databases Work",
    desc: "Embeddings, similarity search, indexing, and meaning-based retrieval.",
  },
];

export function ConceptBanner() {
  return (
    <div className="space-y-2">
      <p className="text-[11px] uppercase tracking-widest text-muted-foreground font-semibold flex items-center gap-1.5">
        <Sparkles className="h-3 w-3 text-primary" />
        Visual Concepts
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {CONCEPTS.map((c, i) => (
          <Link
            key={c.to}
            to={c.to}
            data-track-label={`Concept: ${c.title}`}
            className="group block rounded-xl border border-border hover:border-primary/40 bg-card p-3.5 transition-all overflow-hidden relative"
          >
            <motion.div
              className="absolute inset-0 bg-gradient-to-r from-transparent via-primary/[0.03] to-transparent"
              animate={{ x: ["-100%", "100%"] }}
              transition={{ duration: 4, repeat: Infinity, ease: "linear", delay: i * 0.8 }}
            />
            <div className="relative flex items-center gap-3">
              <div className="shrink-0 flex items-center justify-center h-8 w-8 rounded-lg bg-primary/10 text-primary">
                <c.icon className="h-4 w-4" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold text-xs text-foreground group-hover:text-primary transition-colors">
                  {c.title}
                </h3>
                <p className="text-[10px] text-muted-foreground mt-0.5 line-clamp-1">
                  {c.desc}
                </p>
              </div>
              <ChevronRight className="h-3.5 w-3.5 text-muted-foreground group-hover:text-primary transition-colors shrink-0" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
